module.exports = __webpack_public_path__ + "static/media/2019_IMG_8136.58d63030.jpg";